import {FORTRESS_MELEE_DAMAGE_RATION} from "../../../constants/combat";

export const calculateOrcMeleeDamageForElimination = (unitSize, remainingFortressDurability = 0) => {
  let remainingUnitSize = unitSize;
  let pendingUnitDamage = 0;
  let totalDamage = 0;
  while (remainingUnitSize > 0) {
    if (remainingFortressDurability > 0) {
      totalDamage += FORTRESS_MELEE_DAMAGE_RATION;
      remainingFortressDurability -= 1;
      pendingUnitDamage += 1;
    } else {
      totalDamage += 1;
      pendingUnitDamage += 1;
    }

    if (remainingUnitSize > 1) {
      if (pendingUnitDamage === 3) {
        remainingUnitSize -= 2;
        pendingUnitDamage = 0;
      }
    } else {
      if (pendingUnitDamage === 2) {
        remainingUnitSize -= 1;
        pendingUnitDamage = 0;
      }
    }
  }

  return totalDamage;
  //
  //
  // const damageForProtectedByFortress = sizeProtectedByFortress * 3;
  //
  // const pairSizeCount = Math.floor(unitSize / 2)
  // const oneRemaining = unitSize % 2;
  //
  // return pairSizeCount * 3 + oneRemaining * 2;
}